import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { queryWithPages } from 'donor-elf-web/lib/store-utils';
import NewsletterContactModel from 'donor-elf-web/models/newsletter-contact';
import { type NewsletterRouteModel } from 'donor-elf-web/routes/funds/fund/more/newsletter';

export default class NewsletterSyncController extends Controller {
  @service declare store: Store;

  model!: NewsletterRouteModel;

  @tracked syncMessage = '';
  @tracked syncing = false;
  @tracked syncIsComplete = false;
  @tracked syncHasError = false;
  @tracked error?: any;
  @tracked downloadingNewsletterContacts = true;
  @tracked newsletterContacts: NewsletterContactModel[] = [];
  controllerIsActive = false;

  get newsletterContactsCount() {
    if (this.downloadingNewsletterContacts) {
      return '';
    } else {
      return this.newsletterContacts.length;
    }
  }

  get noNewsletterContacts() {
    return this.newsletterContacts.length === 0;
  }

  @action
  async templateDidInsert() {
    this.controllerIsActive = true;
    await this.downloadNewsletterContacts();
    this.sync();
  }

  @action
  templateWillDestroy() {
    this.controllerIsActive = false;
    this.syncing = false;
    this.syncIsComplete = false;
    this.syncHasError = false;
    this.error = undefined;
    this.downloadingNewsletterContacts = true;
    this.newsletterContacts = [];
  }

  @action
  async downloadNewsletterContacts() {
    this.newsletterContacts = await queryWithPages<NewsletterContactModel>({
      store: this.store,
      modelName: 'newsletter-contact',
      queryOptions: {
        filter: {
          newsletter_account_id: this.model.newsletterAccount!.id,
        },
      },
      pageSize: 500,
    });
    this.downloadingNewsletterContacts = false;
  }

  @action
  async sync() {
    if (this.syncing) {
      return;
    }
    this.syncing = true;
    try {
      this.syncMessage = 'Syncing. . .';
      await this.store
        .createRecord('newsletter-account-sync', {
          newsletterAccountId: this.model.newsletterAccount!.id,
        })
        .save();
      this.updateSyncMessage();
      this.checkSync();
    } catch (e) {
      this.error = e;
    }
  }

  @action
  updateSyncMessage() {
    if (!this.syncing) {
      return;
    }
    setTimeout(() => {
      let syncMessage = `${this.syncMessage} .`;
      if (syncMessage.length > 40) {
        syncMessage = 'Syncing. . .';
      }
      this.syncMessage = syncMessage;
      this.updateSyncMessage();
    }, 500);
  }

  @action
  async checkSync() {
    if (!this.controllerIsActive) {
      return;
    }
    try {
      let syncInfo = await this.store.findRecord(
        'newsletter-account-sync',
        this.model.newsletterAccount!.id,
        { forceReload: true },
      );
      if (syncInfo.hasApiError) {
        this.syncHasError = true;
        this.syncing = false;
      } else if (syncInfo.syncing) {
        setTimeout(() => {
          this.checkSync();
        }, 2000);
      } else {
        this.syncing = false;
        this.syncIsComplete = true;
      }
    } catch (e) {
      this.error = e;
    }
  }
}
